import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
interface LoadingOverlayProps {
  message: string;
  subMessage?: string;
}
export function LoadingOverlay({
  message,
  subMessage
}: LoadingOverlayProps) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.2
  }} className="absolute inset-0 z-50 bg-slate-950/95 flex flex-col items-center justify-center px-8" data-id="element-992">
      <div className="relative mb-6" data-id="element-993">
        <motion.div animate={{
        rotate: 360
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'linear'
      }} className="w-12 h-12 rounded-full border-2 border-slate-800 border-t-orange-500" data-id="element-994" />
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-995">
          <SparklesIcon className="w-4 h-4 text-orange-500" data-id="element-996" />
        </div>
      </div>
      <motion.p initial={{
      opacity: 0,
      y: 5
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.15
    }} className="text-white font-semibold text-base text-center mb-1" data-id="element-997">
        {message}
      </motion.p>
      {subMessage && <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.3
    }} className="text-slate-500 text-xs text-center" data-id="element-998">
          {subMessage}
        </motion.p>}
    </motion.div>;
}